var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a{opacity:0;}.b{fill:none;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1763 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 1763, 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(30 24)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1812.821 53.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H30.357V30.357H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22.238,8.622l-1.9,1.982,3.481,3.64H10.1v2.811H23.816L20.336,20.68l1.9,2,6.746-7.027ZM4.7,5.811H15.492V3H4.7A2.764,2.764,0,0,0,2,5.811V25.487A2.764,2.764,0,0,0,4.7,28.3H15.492V25.487H4.7Z",
    transform: "translate(-0.314 -0.47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.db400ed30b3c45b34e8ae8141907c8cc.svg";
export { ForwardRef as ReactComponent };